import React, { FC } from 'react';
import TermsTemplate from './termsTemplate';

const TermsPage: FC = () => {
  return <TermsTemplate termsDocument="terms" />;
};

export default TermsPage;
